export const PermissionsEnum = {
  VIEW_EXTERNAL_CASHBACK_CAMPAIGN: "view-external-cashback-campaign",
  EDIT_EXTERNAL_CASHBACK_CAMPAIGN: "edit-external-cashback-campaign",
  VIEW_CASHBACK_IMPORTS: "view-cashback-imports",
  MANAGE_CASHBACK_IMPORTS: "manage-cashback-imports",
  VIEW_CASHBACK_ARCHITECT: "view-cashback-architect",
  VIEW_ARC_PLUS: "view-arc-plus"
};
